// import styles from './../../src/abstracts/_shadows.scss';
const styles = {
  shadowColor: { r: 150, g: 161, b: 176, a: 0.5, rgba: 'rgba(150, 161, 176, 0.5)' },
  shadowM: [
    2,
    2,
    8,
    0,
    {
      r: 105,
      g: 118,
      b: 132,
      a: 0.5,
      rgba: 'rgba(105, 118, 132, 0.5)'
    }
  ],
  shadowInput: [
    4,
    4,
    6,
    -1,
    {
      r: 150,
      g: 161,
      b: 176,
      a: 0.5,
      rgba: 'rgba(150, 161, 176, 0.5)'
    }
  ]
}

export default styles;